import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { API_BASE_URL } from '../infra/apiConfig';
import logo from '../img/logoAcs2.png'; // 🔹 adicionando a logo

// =================================================================
// FUNÇÕES DE FORMATAÇÃO DE MÁSCARA
// =================================================================

// CPF: ###.###.###-##
const formatCPF = (value) => {
  if (!value) return "";
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .substring(0, 14);
};

// Telefone: (##) #####-####
const formatTelefone = (value) => {
  if (!value) return "";
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .substring(0, 15);
};

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, watch, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    try {
      await axios.post(`${API_BASE_URL}/cadastrar`, data);
      alert('Cadastro realizado com sucesso! Agora você pode fazer o login.');
      navigate('/');
    } catch (error) {
      console.error("Erro ao cadastrar:", error);
      const errorMessage = error.response?.data?.error || 'Não foi possível realizar o cadastro. Tente novamente mais tarde.';
      alert(`Erro: ${errorMessage}`);
    }
  };

  const handleInputChange = (event, formatFunction) => {
    event.target.value = formatFunction(event.target.value);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 py-10 px-4">
      <div className="w-full max-w-2xl p-8 space-y-6 bg-white rounded-2xl shadow-lg">

        {/* 🔹 Logo e título centralizados */}
        <div className="flex flex-col items-center text-center">
          <img src={logo} alt="Logo" className="w-24 h-24 object-contain mb-3" />
          <h2 className="text-3xl font-extrabold text-gray-900">
            Crie sua conta de Representante
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Já tem uma conta?{' '}
            <Link to="/" className="font-medium text-blue-600 hover:text-blue-500">
              Faça o login
            </Link>
          </p>
        </div>

        {/* 🔹 Formulário */}
        <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
          <h3 className="text-lg font-medium text-gray-800 border-b pb-2">Dados Pessoais</h3>

          <div>
            <label htmlFor="nomeCompleto" className="block text-sm font-medium text-gray-700">Nome completo</label>
            <input
              id="nomeCompleto"
              type="text"
              className={`mt-1 w-full p-2 border ${errors.nomeCompleto ? 'border-red-500' : 'border-gray-300'} rounded-md`}
              {...register("nomeCompleto", { required: "O nome completo é obrigatório." })}
            />
            {errors.nomeCompleto && <p className="text-sm text-red-600">{errors.nomeCompleto.message}</p>}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="dataNascimento" className="block text-sm font-medium text-gray-700">Data de nascimento</label>
              <input
                id="dataNascimento"
                type="date"            
                className={`mt-1 w-full p-2 border ${errors.dataNascimento ? 'border-red-500' : 'border-gray-300'} rounded-md`}
                {...register("dataNascimento", { required: "A data de nascimento é obrigatória." })}
              />
              {errors.dataNascimento && <p className="text-sm text-red-600">{errors.dataNascimento.message}</p>}
            </div>

            <div>
              <label htmlFor="cpf" className="block text-sm font-medium text-gray-700">CPF</label>
              <input
                id="cpf"
                type="text"
                maxLength="14"
                onInput={(e) => handleInputChange(e, formatCPF)}
                className={`mt-1 w-full p-2 border ${errors.cpf ? 'border-red-500' : 'border-gray-300'} rounded-md`}
                {...register("cpf", { required: "O CPF é obrigatório." })}
              />
              {errors.cpf && <p className="text-sm text-red-600">{errors.cpf.message}</p>}
            </div>
          </div>

          <div>
            <label htmlFor="telefone" className="block text-sm font-medium text-gray-700">Telefone com WhatsApp</label>
            <input
              id="telefone"
              type="tel"
              maxLength="15"
              onInput={(e) => handleInputChange(e, formatTelefone)}
              className={`mt-1 w-full p-2 border ${errors.telefone ? 'border-red-500' : 'border-gray-300'} rounded-md`}
              {...register("telefone", { required: "O telefone é obrigatório." })}
            />
            {errors.telefone && <p className="text-sm text-red-600">{errors.telefone.message}</p>}
          </div>

          <h3 className="text-lg font-medium text-gray-800 border-b pt-4 pb-2">Dados Escolares</h3>

          <div>
            <label htmlFor="escola" className="block text-sm font-medium text-gray-700">Escola em que estuda</label>
            <input
              id="escola"
              type="text"
              className={`mt-1 w-full p-2 border ${errors.escola ? 'border-red-500' : 'border-gray-300'} rounded-md`}
              {...register("escola", { required: "O nome da escola é obrigatório." })}
            />
            {errors.escola && <p className="text-sm text-red-600">{errors.escola.message}</p>}
          </div>

          <div>
            <label htmlFor="serie" className="block text-sm font-medium text-gray-700">Série</label>
            <select
              id="serie"
              className={`mt-1 w-full p-2 border ${errors.serie ? 'border-red-500' : 'border-gray-300'} rounded-md`}
              {...register("serie", { required: "Selecione sua série." })}
            >
              <option value="">Selecione sua série</option>
              <option value="8_fundamental">8º Ano - Ensino Fundamental</option>
              <option value="9_fundamental">9º Ano - Ensino Fundamental</option>
              <option value="1_medio">1º Ano - Ensino Médio</option>
              <option value="2_medio">2º Ano - Ensino Médio</option>
              <option value="3_medio">3º Ano - Ensino Médio</option>
            </select>
            {errors.serie && <p className="text-sm text-red-600">{errors.serie.message}</p>}
          </div>

          <div>
            <label htmlFor="categoria" className="block text-sm font-medium text-gray-700">Categoria</label>
            <select
              id="categoria"
              className={`mt-1 w-full p-2 border ${errors.categoria ? 'border-red-500' : 'border-gray-300'} rounded-md`}
              {...register("categoria", { required: "Selecione sua categoria." })}
            >
              <option value="">Selecione sua categoria</option>
              <option value="EX ALUNO DO PASSAPORTE DIGITAL">EX-ALUNO DO PASSAPORTE DIGITAL</option>
              <option value="ALUNO ATUAL DO PASSAPORTE DIGITAL">ALUNO ATUAL DO PASSAPORTE DIGITAL</option>
              <option value="ESTUDANTE DA REDE DE ESCOLAS DO MUNICÍPIO DE LAGOA DE ITAENGA">
                ESTUDANTE DA REDE DE ESCOLAS DO MUNICÍPIO DE LAGOA DE ITAENGA
              </option>
            </select>
            {errors.categoria && <p className="text-sm text-red-600">{errors.categoria.message}</p>}
          </div>


          <h3 className="text-lg font-medium text-gray-800 border-b pt-4 pb-2">Dados de Acesso</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">E-mail de contato</label>
              <input
                id="email"
                type="email"
                className={`mt-1 w-full p-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-md`}
                {...register("email", { required: "O e-mail é obrigatório.", pattern: { value: /^\S+@\S+$/i, message: "E-mail inválido." } })}
              />
              {errors.email && <p className="text-sm text-red-600">{errors.email.message}</p>}
            </div>

            <div>
              <label htmlFor="usuario" className="block text-sm font-medium text-gray-700">Usuário</label>
              <input
                id="usuario"
                type="text"
                className={`mt-1 w-full p-2 border ${errors.usuario ? 'border-red-500' : 'border-gray-300'} rounded-md`}
                {...register("usuario", { required: "O nome de usuário é obrigatório." })}
              />
              {errors.usuario && <p className="text-sm text-red-600">{errors.usuario.message}</p>}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">Senha</label>
              <input
                id="password"
                type="password"
                className={`mt-1 w-full p-2 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded-md`}
                {...register("password", { required: "A senha é obrigatória.", minLength: { value: 6, message: "A senha precisa ter no mínimo 6 caracteres." } })}
              />
              {errors.password && <p className="text-sm text-red-600">{errors.password.message}</p>}
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">Confirme a senha</label>
              <input
                id="confirmPassword"
                type="password"
                className={`mt-1 w-full p-2 border ${errors.confirmPassword ? 'border-red-500' : 'border-gray-300'} rounded-md`}
                {...register("confirmPassword", { required: "Confirme sua senha.", validate: value => value === watch('password') || "As senhas não coincidem." })}
              />
              {errors.confirmPassword && <p className="text-sm text-red-600">{errors.confirmPassword.message}</p>}
            </div>
          </div>

          <div className="pt-4">
            <button
              type="submit"
              className="w-full px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition"
            >
              Criar conta e Prosseguir
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;
